import { FREE_VARIABLE_SEED_COLORS } from "../../consts";
import {
  generatePaletteFromSeedColors,
  generateSeedColorsFromVariableSeedColors
} from "../../utils";

export const freeSeedColors = generateSeedColorsFromVariableSeedColors(
  FREE_VARIABLE_SEED_COLORS
);

export const freePalette = generatePaletteFromSeedColors(freeSeedColors);
